export default [
  {
    path: "warehouse/package-return",
    name: "PackageReturn",
    component: () => import("@/pages/Warehouse/PackageReturn.vue"),
    meta: {
      title: "退回件明细",
      requireAuth: true,
    },
  },
  {
    path: "warehouse/daily-clean",
    name: "DailyClean",
    component: () => import("@/pages/Warehouse/DailyClean.vue"),
    meta: {
      title: "日清点货数据",
      requireAuth: true,
    },
  },
  {
    path: "warehouse/centre-convergence",
    name: "CentreConvergence",
    component: () => import("@/pages/Warehouse/CentreConvergence/Index.vue"),
    meta: {
      title: "预汇集列表",
      requireAuth: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/warehouse.js